import { getPropsFromNode, nodeListToArray, nodeMatches } from '../utils'

import { buildFigureComponent } from './blocks/image'

export const NAME = 'caption'

export function matches(node) {
  return nodeMatches(node, '.wp-caption')
}

export async function transform (node, next, ctx) {
  const id = node.id

  const captionID = `caption-${id.replace('_', '-')}`

  const nodes = nodeListToArray(node.childNodes)

  const [caption, children] = await Promise.all([
    next(
      nodes.filter(node => node.id === captionID),
      ctx,
    ),
    next(
      nodes.filter(node => node.id !== captionID),
      ctx,
    ),
  ])

  const props = {
    ...getPropsFromNode(node, ['id', 'class', 'style']),
    caption,
  }

  return buildFigureComponent(
    ctx,
    node,
    props,
    children,
  )
}
